module.exports = __webpack_public_path__ + "static/media/Done.0dbc6b97.svg";